import { useEffect } from 'react';

import { useSectionRegistryDispatch } from './SectionRegistryContext';

export default function useRegisterSection(sectionId: string, isVisible: boolean = true) {
  const { registerSection, unregisterSection } = useSectionRegistryDispatch();

  useEffect(() => {
    if (isVisible) {
      registerSection(sectionId);
    } else {
      unregisterSection(sectionId);
    }
    return () => unregisterSection(sectionId);
  }, [sectionId, isVisible, registerSection, unregisterSection]);
}
